import { Injectable } from '@angular/core';
import {  HttpGeneralService } from '../../shared/shared';
import {UsersGroup} from './usersGroup';
import { CONFIG } from '../../shared/config';
let usersGroupsUrl = CONFIG.baseUrls.usersGroups;
let SecLoginsUrl = CONFIG.baseUrls.SecUserLogins;
export interface SecLogins {
    id: number;
    userId: number;
    groupId: number;
    branchId: number;
    active: number;
}

@Injectable()
export class UsersGroupService {
    constructor(private httpGeneralService: HttpGeneralService) {}

    getUsersGroups() {
        return this.httpGeneralService.getWith(`${usersGroupsUrl}/all`);
    }
    GetAllUsers(groupid :number) {
        return this.httpGeneralService.getWith(`${usersGroupsUrl}/${groupid}/GetAllUsers`);
    }
    getGroups(id: number) {
        return this.httpGeneralService.getWith(`${usersGroupsUrl}/${id}/getGroupsByUserId`);
    }
  //add groups to one user
     addGroupsToUser(usersGroup: UsersGroup[]) {
         return this.httpGeneralService.addCollection(usersGroup, `${usersGroupsUrl}/addGroupsToUser`);
    }
    addUsersGroup(usersGroup: UsersGroup[]) {
        return this.httpGeneralService.addCollection(usersGroup, usersGroupsUrl);
    }
    getUsersGroup(userGroupCode: number) {
        return this.httpGeneralService.get(userGroupCode, usersGroupsUrl);
    }
    updateUsersGroup(usersGroup: UsersGroup) {
        return this.httpGeneralService.update(usersGroup.id, usersGroup, usersGroupsUrl);
    }

    deleteUsersGroup(usersGroup: any) {
        return this.httpGeneralService.delete(usersGroup.groupId,`${usersGroupsUrl}/${usersGroup.code}`);
    }



    /// seclogins
    getSecLogins(id: number) {
        return this.httpGeneralService.get(id, SecLoginsUrl);
    }

    getSecLoginsByGroupId(groupId: number) {
        return this.httpGeneralService.get(groupId, `${SecLoginsUrl}/GetSecUserLoginsByGroupId`);
    }

    addSecLogins(SecLogins: SecLogins) {
        return this.httpGeneralService.add<SecLogins>(SecLogins, SecLoginsUrl);
    }

    updateSecLogins(SecLogins: SecLogins) {
        return this.httpGeneralService.update<SecLogins>(SecLogins.id, SecLogins, SecLoginsUrl);
    }

    deleteSecLogins(SecLogins: SecLogins) {
        return this.httpGeneralService.delete<number>(SecLogins.id, SecLoginsUrl);
    }

}
